import React, { useState } from "react";
import { Boxed } from "./Boxed.components";
import { Text } from "./Text.components";
import { Button } from "./Button.components";
import { Theme } from "../utils/theme";

export const Step = ({ step, setActive,  delFunc, isActive }) => {
  return (
    <Boxed
      bColor="#fff"
      display="flex"
      alignItems="center"
      pad="10px"
      cursor="pointer"
      onClick={setActive}
      border={isActive ? "1px solid #0F3BAB" : ""}
      borderRadius={Theme.SecondaryRadius}
      margin="4px 0"
    >
      <Boxed
        bColor={isActive ? "#0F3BAB" :  "#D9D9D9"}
        pad="1px 8px"
        margin="0 6px"
      >
        <Text color={isActive ? "#fff" : "#454545"}>{step}</Text>
      </Boxed>
      <span style={{ margin: "0 6px" }}>Step {step}</span>
      {(step !== 1) && <Boxed
        bColor="rgb(252 165 165)"
        border="1px dashed rgb(220 38 38)"
        borderRadius="4px"
        pad="4px"
        cursor="pointer"
        onClick={delFunc}
      >
        <i className="icon-trash" style={{color: "rgb(220 38 38)" }}/>
      </Boxed>}
    </Boxed>
  );
};

export const StepList = ({
  setCurrentStep,
  updateStep,
  allSteps,
  activeStep,
  resetFields,
}) => {
  const addNewStage = () => {
    updateStep((prev) => [
      ...prev,
      {
        id: `${new Date().toISOString()}`,
        reviewers: [],
        defaultCriteria: 0,
        additionalCriteria: 0,
      },
    ]);
  };

  const deleteStage = (id) => {
    const newSteps = allSteps.filter(item => item.id !== id);
    updateStep(newSteps)
    setCurrentStep(1)
  };

  return (
    <Boxed margin="12px 0">
      {allSteps.map((stage, index) => {
        return (<Step
          key={index}
          step={index + 1}
          setActive={() => {resetFields(); setCurrentStep(stage?.id);}}
          delFunc={() => deleteStage(stage?.id)}
          isActive={activeStep?.id === stage?.id}
        />)
      })}
      <Button
        margin="8px 0"
        disabled={allSteps.length === 10 ? true : false}
        onClick={addNewStage}
      >
        <i className="icon-plus" />
        Step
      </Button>
    </Boxed>
  );
};


